module.exports = __webpack_public_path__ + "media/images/prod-bg-8af8c02649385161a078bbedb3210a27.svg";